export default {
  'maintenance.title': 'Bakımdayız!',
  'maintenance.desc':
    'Bu sayfa bakımdadır. Biran önce bakım çalşmalarını tamamlamak için çalışıyoruz. Anlayışınız için teşekkürler.',
  'maintenance.toHome': 'Anasayfaya Dön',
};
